import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"

const TitleContentPoint = ({ title, richContent, items }) => {
  return (
    <section className={`title-content-point`}>
      <div className="title-content-point__inner">
        {title &&
          <div className="title-content-point__title">
            <div className="line line--horizon center-left"></div>
            <h2>{parse(title)}</h2>
          </div>
        }

        <div className="title-content-point__content">
          <div className="title-content-point__left">
            {richContent && <StructuredText data={richContent} />}
          </div>

          <div className="title-content-point__right">
            {
              items?.length > 0 &&
              <ul>
                {
                  items.map((item, i) => (
                    <li key={i}>{parse(item.title)}</li>
                  ))
                }
              </ul>
            }
          </div>
        </div>
      </div>
    </section>
  )
}

export default TitleContentPoint

export const query = graphql`
fragment TitleContentPointProps on DatoCmsTitleContentPoint {
  ... on DatoCmsTitleContentPoint {
    id
  }
  title
  richContent {
    value
  }
  items {
    title
  }
}
`